<!--
  The header shows ONLY what the branding profile provides.

  Reskin unit D put a hardcoded "getcovered" wordmark here, with a × separator
  before the property logo. That baked our brand into every white-label header
  regardless of what the client's branding profile said, so a property with its
  own logo still rendered our name beside it. Removed: <app-logo-section> already
  renders `logo_url` / `second_logo_url` (single, dual, `logo_custom_url` and
  iframe behaviour all handled there), and if the branding supplies neither, the
  header correctly shows no logo at all rather than falling back to ours.

  The wrapper element stays: it is the styling context that sizes the property
  logo slim for the header bar (assets/styles/components/header-logo/header-logo.scss)
  and the grid cell the header centres (header.component.css).
-->
<div class="cobrand-lockup">
  <app-logo-section></app-logo-section>
</div>
